import firebase from "firebase";
const config = {
  apiKey: "AIzaSyCTZaRLcMMP08elRaqmUrT7ZWU7niwQUeU",
  authDomain: "trim-direct.firebaseapp.com",
  databaseURL: "https://trim-direct.firebaseio.com",
  projectId: "trim-direct",
  storageBucket: "trim-direct.appspot.com",
  messagingSenderId: "180282322892",
  appId: "1:180282322892:web:f1a687b3a9a6085ecdb769",
  measurementId: "G-VNSP6215WG",
};
firebase.initializeApp(config);
export default firebase;
